import produce from 'immer'
import _ from 'lodash'

import {
  RECORD_INFRACTIONS_LOAD,
  RECORD_INFRACTIONS_LOAD_SUCCESS,
  RECORD_INFRACTIONS_LOAD_FAILURE,
  RECORD_INFRACTIONS_CLEAR
} from './actions'

const initialState = {
  loading: false,
  error: null,
  record: {
    list: [],
    byFieldName: {}
  }
}

const reducer = (state = initialState, action) => {
  const tempRecord = {}
  if (action.infractions) {
    tempRecord.list = action.infractions
    tempRecord.byFieldName = _.keyBy(action.infractions, i => i.fieldName)
  }

  return produce(state, draft => {
    switch (action.type) {
      case RECORD_INFRACTIONS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case RECORD_INFRACTIONS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null

        draft.record = tempRecord
        return
      }
      case RECORD_INFRACTIONS_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      case RECORD_INFRACTIONS_CLEAR: {
        draft.loading = false
        draft.error = null
        draft.record = { list: [], byFieldName: {} }
        return
      }
    }
  })
}

export { reducer }
